
import {defaultLocale,localeOptions} from '../../constants/defaultValues'
import { keySelectedStore } from '../../constants/localStorageKeys'

import {
	CHANGE_LOCALE,
	CHANGE_STORE,
	CHANGE_FEATURE_TOGGLE,
	CHANGE_TENANT_INFO,
} from '../actions';

const getTenantInfoFromStorage = () => {
	try {
		const stored = localStorage.getItem('tenantInfo');
		return stored ? JSON.parse(stored) : null;
	} catch (error) {
		console.error('Error parsing tenantInfo from localStorage:', error);
		return null;
	}
};

// A loja já entra no estado inicial. É o que faz a tela sobreviver ao recarregamento da troca de
// tema: sem isso ela monta com `store` indefinido e cai fora sozinha. O topo confirma logo em
// seguida contra a lista do servidor, então uma loja fora da lista não sobrevive.
const getSelectedStoreFromStorage = () => {
	try {
		const stored = localStorage.getItem(keySelectedStore);
		return stored ? JSON.parse(stored) : undefined;
	} catch (error) {
		console.error('Error parsing selectedStore from localStorage:', error);
		return undefined;
	}
};

const INIT_STATE = {
	locale: (localStorage.getItem('currentLanguage') && localeOptions.filter(x=>x.id===localStorage.getItem('currentLanguage')).length>0) ? localStorage.getItem('currentLanguage') : defaultLocale,
	tenantInfo: getTenantInfoFromStorage(),
	store: getSelectedStoreFromStorage(),
};

const settingsReducer = (state = INIT_STATE, action) => {
	switch (action.type) {
		case CHANGE_LOCALE:
		return { ...state, locale:action.payload};

		case CHANGE_STORE:
		return { ...state, store:action.payload};

		case CHANGE_FEATURE_TOGGLE:
		return { ...state, featureToggle:action.payload};

		case CHANGE_TENANT_INFO:
		return { ...state, tenantInfo:action.payload};

		default: return { ...state };
	}
};

export default settingsReducer;